import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  computed,
  ElementRef,
  inject,
  input,
  OnDestroy,
  Signal,
  ViewChild,
} from '@angular/core';
import { AddFrPipe } from '@shared/pipes/add-fr.pipe';
import { IBreadcrumbsItem, IContentItem, IDetails_Response } from '@shared/constants/models.const';
import { ClickOutside } from '@shared/directives/click-outside';
import { IGNORE } from '@shared/constants/enums.const';
import { NgTemplateOutlet } from '@angular/common';
import { debounceTime, fromEvent, Subscription } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-breadcrumbs',
  imports: [
    AddFrPipe,
    ClickOutside,
    NgTemplateOutlet,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './breadcrumbs.component.html',
  styleUrl: './breadcrumbs.component.scss',
})
export class BreadcrumbsComponent implements AfterViewInit, OnDestroy {
  @ViewChild('testWrapper') testWrapper!: ElementRef;
  @ViewChild('lastElem') lastElem!: ElementRef;
  @ViewChild('brWrapper') brWrapper!: ElementRef;
  pageData = input.required<IDetails_Response>();
  showShortBreadcrumbs = false;
  hideTest = false;
  showDropdown = false;
  showDropdownSiblings = false;
  cd: ChangeDetectorRef = inject(ChangeDetectorRef);
  isMobile = false;
  pageDataBreadcrumb: Signal<IBreadcrumbsItem[]> = computed(() => {
    return this.pageData()?.breadcrumbs || [];
  });
  pageDataSiblings: Signal<IContentItem[]> = computed(() => {

    let result = [];
    if (this.pageData()?.children?.length) {
      result = this.pageData()?.children;
    }

    if (!result.length && this.pageData()?.siblings?.length) {
      result = this.pageData()?.siblings as IContentItem[];
    }

    result = result.filter((item: IContentItem) => item.id !== this.pageData().id);

    return result;
  });
  useRightPosition = false;
  private resizeSubscription!: Subscription;

  pxToNumber(value: any): number {
    return Number(value.replace('px', ''));
  }

  ngAfterViewInit() {

    this.isMobile = window.innerWidth <= 798;
    this.resizeSubscription = fromEvent(window, 'resize')
      .pipe(
        untilDestroyed(this),
        debounceTime(100),
      )
      .subscribe(() => {
        this.isMobile = window.innerWidth <= 798;
        this.cd.markForCheck();

        this.hideTest = false;
        setTimeout(() => {
          this.setWidths();
        }, 70);
      });

    this.setWidths();


  }

  setWidths() {
    const maxWidthOfCenter = 780;
    const testElement = this.testWrapper?.nativeElement;
    const mainSection = document.querySelector('app-three-column-template > app-section-template > .section-wrapper');

    let maxWidth = 480;
    const forLuck = 5;
    if (mainSection) {

      const styles = getComputedStyle(mainSection);
      const { paddingLeft, paddingRight, width } = styles;
      maxWidth = Math.floor(this.pxToNumber(width) - this.pxToNumber(paddingLeft) - this.pxToNumber(paddingRight) - forLuck);

      if (maxWidth > maxWidthOfCenter) maxWidth = maxWidthOfCenter;
      if (this.brWrapper?.nativeElement) {
        this.brWrapper.nativeElement.style.maxWidth = maxWidth + 'px';
      }

    }

    if (testElement) {
      this.showShortBreadcrumbs = (testElement.scrollWidth + forLuck) > maxWidth;
      this.cd.markForCheck();
    }

    this.hideTest = true;
    this.cd.detectChanges();

    const lastElem = this.lastElem?.nativeElement;
    if (lastElem && lastElem.scrollWidth > 200) {
      lastElem.classList.add('three-dots');
      this.cd.detectChanges();
    }

  }

  clickOutside($event: any) {
    if (!$event?.target?.getAttribute('class')?.includes(IGNORE)) {
      this.showDropdown = false;
      this.showDropdownSiblings = false;
    }
  }

  toggleBreadcrumbs($event: MouseEvent) {
    $event.stopPropagation();
    this.showDropdownSiblings = false;
    this.showDropdown = !this.showDropdown;
  }

  toggleSiblings($event: MouseEvent) {
    this.useRightPosition = window.innerWidth < 530;

    $event.stopPropagation();
    this.showDropdown = false;
    this.showDropdownSiblings = !this.showDropdownSiblings;
  }


  ngOnDestroy() {
    this.resizeSubscription.unsubscribe();
  }
}
